module.exports = __webpack_public_path__ + "static/img/video_quiz.63636e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/quiz_center/video_quiz.png
// module id = O++1
// module chunks = 1